// /* eslint-disable jsx-a11y/anchor-is-valid */
// import { Disclosure, Tab } from "@headlessui/react";
// import React, { Fragment, useEffect, useState } from "react";
// import { ClassicSpinner } from "react-spinners-kit";
// import { CourseCloudFrontDistributionID } from "../../api/aws-api";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Link, useNavigate } from "react-router-dom";
// import { UpdatePostgreSQL } from "../../api/aws-api";
// import { ConstructorEventPost } from "../../Event/event";
// import {
//   author,
//   camera,
//   fb,
//   file2,
//   headphone,
//   instra,
//   laptop,
//   likeIcon,
//   ln,
//   lock,
//   Anglofone_CourseImage,
//   starIcon,
//   target,
//   twitter,
//   user,
//   user2,
//   ux,
//   yt,
//   rc1,
//   rc2,
//   rc3,
//   clockIcon,
//   cmnt1,
//   dymmyUser,
// } from "../../constant/images";
// import Course_Review from "./Course_Review";



// const CourseDetails = (props) => {

//   useEffect(() => {
//     const userId = JSON.parse(localStorage.getItem("UserKey"))
//     const userData = JSON.parse(sessionStorage.getItem("UserData"))
//     console.log(`the userId in local is ${userId.user_id}`)
//     console.log(`the userdata in session is ${userData.user_name}`)
//     console.log(`the usertype in session is ${userData.user_type}`)
//     console.log(`the mentor name for the particular course is ${props.courseProps.batch_mentor_name}`)

//     const datass = {
//       userId: userId.user_id,
//       userName: userData.user_name,
//       mentorName: props.courseProps.batch_mentor_name,
//       userType: userData.user_type
//     }

//     console.log(datass)

//     setCallActivityData(datass)
//   }, [])



//   const [showReviewTab, setShowReviewTab] = useState(false);
//   const [callActivityData, setCallActivityData] = useState({})
//   const [ModuleID, setMOduleID] = useState(null)
//   const [TaskID, setTaskID] = useState(null)
//   const [userId, setUserId] = useState(null);
//   const [courseId, setCourseId] = useState(null);
//   const [taskId, setTaskId] = useState(null);
//   const [moduleId, setModuleId] = useState(null);
//   const navigate = useNavigate();
//   const module_id = props
//   console.log(module_id)
//   const calculateTotalReview = () => {
//     if (
//       props.CourseDetails !== undefined &&
//       props.CourseDetails.course_star !== undefined
//     ) {
//       let total_starvalue = 0;
//       for (let i = 1; i < 6; i++) {
//         total_starvalue =
//           total_starvalue + props.CourseDetails.course_star[i] * parseInt(i);
//       }
//       const percentage = (
//         total_starvalue / parseInt(props.CourseDetails.course_star["total"])
//       ).toFixed(1);
//       return percentage;
//     }
//   };
//   const totalreview = calculateTotalReview();

//   const handleJoinNow = () => {
//     const meetLink =
//       props.courseProps && props.courseProps.next_class_details.meet_link;
//     console.log(meetLink, "lommk");
//     window.open(meetLink, "_blank"); // Open the meet link in a new tab
//   };

//   const HandleActivityNavigation = (resource) => {
//     console.log(`the resource url is ${resource.url}`)
//     console.log(`the module id is ${resource.module_id}`)
//     console.log(`the task id is ${resource.task_id}`)

//     localStorage.setItem("module_id", resource.module_id)
//     localStorage.setItem("task_id", resource.task_id)

//     const storedModuleId = localStorage.getItem("module_id")
//     const storedTaskId = localStorage.getItem("task_id")

//     const storedUserId = localStorage.getItem("UsersID");
//     const storedCourseId = localStorage.getItem("Course_ID")

//     const batchdetails = JSON.parse(localStorage.getItem("batch_Details") || "[]");

    
    
//     if (resource.url === "/codomo/codeeditor") {
//       navigate("/codomo/codeeditor", {
//         state: { resource: resource, CourseProps: props.courseProps },
//       });
//     } else if (resource.url === "/codomo/AcitivityCourse") {
//       navigate("/codomo/AcitivityCourse", {
//         state: { resource: resource, CourseProps: props.courseProps },
//       });
//     } else if (resource.url === "/codomo/NewAcitivityCourse") {
//       navigate("/codomo/NewAcitivityCourse");
//     } else if (resource.url.includes("onecompiler.com")) {
//       // navigate("/codomo/onecompiler",{state: {"Url" : resource.url}})
//       sessionStorage.setItem("OneCompilerUrl", resource.url);
//       const newTab = window.open("", "_blank");

//       // Navigate in the new tab or window
//       newTab.location = "/codomo/onecompiler";
//     }  else if (resource.url.includes("onecompiler.com")) {
//   sessionStorage.setItem("OneCompilerUrl", resource.url);
//   const newTab = window.open("", "_blank");
//   newTab.location = "/codomo/onecompiler";
//     }  else if (resource.url.includes("scratch.mit.edu")) {
//   // Open EXACT URL from resource.url
//   window.open(resource.url, "_blank", "noopener,noreferrer");


//     } else if (resource.url.includes("polypad")) {

//       sessionStorage.setItem("OneCompilerUrl", resource.url);
//       const newTab = window.open("", "_blank");

//       // Navigate in the new tab or window
//       newTab.location = "/codomo/onecompiler";



//     }
//     else {
//       console.log('the module id is ', storedModuleId)
//       console.log("the task id is", storedTaskId)
//       console.log('the course 1 is ', storedCourseId)
//       console.log("the user id is", storedUserId)
//       console.log("the batch is", batchdetails)

//       const matchedBatch = batchdetails.find(batch => batch.course_id === storedCourseId);

      

// if (matchedBatch) {
//   console.log("Matching batch_id is:", matchedBatch.batch_id);
//   localStorage.setItem("batch_id_match",matchedBatch.batch_id)


// } else {
//   console.warn("No batch found for course_id:", storedCourseId);
// }


//       if (storedUserId && storedCourseId && storedModuleId && storedTaskId && matchedBatch) {

//         function getISTTimeString() {
//           const now = new Date();

//           const year = now.getFullYear();
//           const month = String(now.getMonth() + 1).padStart(2, "0");
//           const day = String(now.getDate()).padStart(2, "0");
//           const hours = String(now.getHours()).padStart(2, "0");
//           const minutes = String(now.getMinutes()).padStart(2, "0");
//           const seconds = String(now.getSeconds()).padStart(2, "0");

//           return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
//         }

//         const istISOString = getISTTimeString();

//         console.log("IST time is:", istISOString);

//         console.log("UserID is", storedUserId);
//         console.log("CourseID is", storedCourseId);
//         console.log("TAskID is", storedTaskId);
//         console.log("ModuleID is", storedModuleId);
//         console.log("batch id is ss",matchedBatch.batch_id)
//         setUserId(storedUserId);
//         setCourseId(storedCourseId);
//         setTaskId(storedTaskId)
//         setModuleId(storedModuleId)


//         console.log("time is ", istISOString)

//         const params = {
//           user_id: storedUserId,
//           course_id: storedCourseId,
//           module_id: storedModuleId,
//           task_id: storedTaskId,
//           completed_at: istISOString,
//           last_updated: istISOString,
//           batch_id: matchedBatch.batch_id
//         };

//         const postCompletionEvent = async () => {
//           try {
//             const responsedata = await ConstructorEventPost(UpdatePostgreSQL, params);
//             console.log("Event post success:", responsedata);
//           } catch (error) {
//             console.error("Event post failed:", error);
//           }
//         };

//         postCompletionEvent();

//       } else {
//         console.log("Waiting for IDsss...");
//       }


//       // window.open(resource.url, "_blank", "noopener noreferrer");
//       // window.open(resource.url, "_self");
//       window.open(resource.url, "_blank", "noopener,noreferrer");


//     }
//   };

//   function goToVoiceCallPage() {
//     console.log(callActivityData)
//     navigate("/voiceCallActivity", { state: callActivityData })
//     // navigate("/chatScreen", { state: callActivityData })
//   }

//   function goToVideoCallPage() {
//     console.log(callActivityData)
//     navigate("/videoCallActivity", { state: callActivityData })
//   }

//   function goToChatScreenPage() {
//     navigate("/chatScreen", { state: callActivityData });
//   }



//   return props.loading ? (
//     <div className="spinner">
//       <div className="spinner-wrapper">
//         <ClassicSpinner size={50} color="black" loading={props.loading} />
//       </div>
//     </div>
//   ) : (
//     <div className="nav-tab-wrapper tabs  section-padding">
//       <div className="container">
//         <div className="grid grid-cols-12 gap-[30px]">
//           <div className="lg:col-span-8 col-span-12">
//             <div className="single-course-details">
//               {/* <div className="xl:h-[470px] h-[350px] mb-10 course-main-thumb">
//                 <img
//                   src={props.CourseDetails ? CourseCloudFrontDistributionID +"/" + props.CourseDetails.course_id + "/images/" + props.CourseDetails.course_image  : Anglofone_CourseImage}
//                   alt=""
//                   className=" rounded-md object-fut w-full h-full block"
//                 />
//               </div> */}

//               <div className="mb-6" style={{ display: "flex", justifyContent: "space-between" }}>
//                 <span className="bg-secondary py-1 px-3 text-lg font-semibold rounded text-white">
//                   {props.CourseDetails
//                     ? props.CourseDetails.course_catogory
//                     : "course_catogory"}
//                 </span>
//                 <div>

//                   {/* New update waiting for approval */}

//                   {/* <button className="bg-secondary py-1 px-3 text-lg font-semibold rounded text-white" onClick={goToVoiceCallPage}>Voice Call</button>
//                   {" "}
//                   <button className="bg-secondary py-1 px-3 text-lg font-semibold rounded text-white" onClick={goToVideoCallPage}>Video Call</button>
//                   {" "}
//                   <button className="bg-secondary py-1 px-3 text-lg font-semibold rounded text-white" onClick={goToChatScreenPage}>Chat</button>
//                   {" "} */}
//                   {/* {callActivityData.userType == "mentor" ? <select className="bg-secondary py-1 text-lg font-semibold rounded text-white">
//                     <option>Select a student</option>
//                   </select> : ""} */}
//                 </div>

//               </div>
//               <h2>
//                 {props.CourseDetails
//                   ? props.CourseDetails.course_name
//                   : "course_name"}
//               </h2>
//               <Tab.Group>
//                 <div className="nav-tab-wrapper mt-12">
//                   <Tab.List as="ul" id="tabs-nav" className="course-tab mb-8">
//                     {["Curriculum", "Downloads"].map((item, index) => (
//                       <Tab
//                         as="li"
//                         key={index}
//                         className={({ selected }) =>
//                           selected ? "active" : null
//                         }
//                       >
//                         <a href={`#tab`}>{item}</a>
//                       </Tab>
//                     ))}
//                   </Tab.List>
//                   <Tab.Panels id="tabs-content">
//                     <Tab.Panel id="tab2" className="tab-content">
//                       <div>
//                         <h3 className=" text-2xl">Course Description</h3>
//                         <div className="md:flex md:space-x-10  space-x-3 flex-wrap mt-4 mb-6">
//                           <span>
//                             {props.CourseDetails
//                               ? props.CourseDetails.description
//                               : "description"}
//                           </span>
//                         </div>
//                         <span>
//                           <h5>
//                             Lectures Total:{" "}
//                             {props.CourseDetails
//                               ? props.CourseDetails.duration
//                               : "description"}
//                           </h5>
//                         </span>
//                         <ul className="list  course-accrodain space-y-6">
//                           {props.CourseDetails
//                             ? props.CourseDetails.modules.map(
//                               (module, index) => (
//                                 <Disclosure as="li">
//                                   {({ open }) => (
//                                     <li
//                                       className={open ? "open" : ""}
//                                       key={index}
//                                     >
//                                       <Disclosure.Button
//                                         as="button"
//                                         className="accrodain-button"
//                                       >
//                                         <span className="icon-pm fle x-none"></span>
//                                         <span className=" flex-1">
//                                           {module.module_name}
//                                         </span>
//                                         <div className="flex-none extra-text  hidden sm:block">
//                                           {module.Lectures} Lectures,{" "}
//                                           {module.TotalDurationInMinutes} min
//                                         </div>
//                                       </Disclosure.Button>
//                                       <Disclosure.Panel>
//                                         <div className="content">
//                                           <div className=" text-xl font-semibold text-black mb-2">
//                                             {module.description_head}
//                                           </div>
//                                           <p>{module.description}</p>
//                                           <div className=" text-xl font-semibold text-black mb-2 mt-6">
//                                             {module.resource_count
//                                               ? module.resource_count.video
//                                                 ? module.resource_count
//                                                   .video + " Videos  "
//                                                 : ""
//                                               : ""}
//                                             {module.resource_count
//                                               ? module.resource_count.audio
//                                                 ? module.resource_count
//                                                   .audio + " Audio  "
//                                                 : ""
//                                               : ""}
//                                             {module.resource_count
//                                               ? module.resource_count.activity
//                                                 ? module.resource_count
//                                                   .activity + " Activity  "
//                                                 : ""
//                                               : ""}
//                                           </div>
//                                           <div className=" mt-8 "   >
//                                             {module.resource.map(
//                                               (resource, index) => (
//                                                 <div
//                                                   className="flex items-start pb-4 mb-4 last:mb-0 last:pb-0 border-b border-[#ECECEC] last:border-0"
//                                                   key={index}
//                                                   onClick={() =>
//                                                     HandleActivityNavigation(
//                                                       resource
//                                                     )
//                                                   }
//                                                 >
//                                                   <div className="flex-1 flex"  target="_blank">
//                                                     <span className="flex-none mr-2"  >
//                                                       <img
//                                                         src={
//                                                           resource.type ===
//                                                             "Video"
//                                                             ? camera
//                                                             : resource.type ===
//                                                               "Audio"
//                                                               ? headphone
//                                                               : resource.type ===
//                                                                 "Activity"
//                                                                 ? laptop
//                                                                 : ""
//                                                         }
//                                                         alt=""
//                                                       />
//                                                     </span>
                                                    
//                                                     <span className="flex-1"  >
//                                                       {" "}
//                                                       {resource.type}:{" "}
//                                                       {resource.description}{" "}
//                                                     </span>
//                                                   </div>
//                                                   <div className="flex-none flex space-x-3"  >
//                                                     {resource.preview ? (
//                                                       <span className="bg-primary text-white px-3 rounded">
//                                                         Preview
//                                                       </span>
//                                                     ) : (
//                                                       ""
//                                                     )}

//                                                     {resource.locked ? (
//                                                       <img
//                                                         src={lock}
//                                                         alt=""
//                                                       />
//                                                     ) : (
//                                                       ""
//                                                     )}
//                                                   </div>
//                                                 </div>
//                                               )
//                                             )}
//                                           </div>
//                                         </div>
//                                       </Disclosure.Panel>
//                                     </li>
//                                   )}
//                                 </Disclosure>
//                               )
//                             )
//                             : " error"}
//                         </ul>
//                       </div>
//                     </Tab.Panel>
//                     <Tab.Panel id="tab3" className="tab-content">
//                       <div className=" bg-[#F8F8F8] rounded-md p-8">
//                         <div className="md:flex space-x-5 mb-8">
//                           <div className="h-[310px] w-[270px] flex-none rounded mb-5 md:mb-0">
//                             <img
//                               src={dymmyUser}
//                               alt=""
//                               className=" w-full h-full object-cover  rounded"
//                             />
//                           </div>
//                           <div className="flex-1">
//                             <div className="max-w-[300px]">
//                               <h4 className=" text-[34px] font-bold leading-[51px]">
//                                 {props.courseProps &&
//                                   props.courseProps.batch_mentor_name}
//                               </h4>
//                               <div className=" text-primary mb-6">
//                                 Course Mentor
//                               </div>
//                               <ul className=" list space-y-4">
//                                 <li className=" flex space-x-3">
//                                   <img src={file2} alt="" />
//                                   <div>3 Courses</div>
//                                 </li>

//                                 <li className=" flex space-x-3">
//                                   <img src={user2} alt="" />
//                                   <div>10 Student Learned</div>
//                                 </li>

//                                 <li className=" flex space-x-3">
//                                   <img src={starIcon} alt="" />
//                                   <div>10+ Reviews</div>
//                                 </li>

//                                 <li className=" flex space-x-3">
//                                   <img src={likeIcon} alt="" />
//                                   <div>4.9 Average Rating</div>
//                                 </li>
//                               </ul>
                             
//                             </div>
//                           </div>
//                         </div>
//                         <p>
//                           There are many variations of passages of Lorem Ipsum
//                           available, but the majority have suffered alteration
//                           in some form, by injected humour, or randomised words
//                           which don't look even slightly believable. If you are
//                           going to use a passage of Lorem Ipsum, you need to be
//                           sure there isn't anything embarrassing hidden in the
//                           middle of text. All the Lorem Ipsum generators on the
//                           Internet tend.
//                         </p>
//                       </div>
//                     </Tab.Panel>
//                     <Tab.Panel as="div" id="tab4" className="tab-content">
//                       <div>
//                         <div className="grid grid-cols-12 gap-5">
//                           <div className="md:col-span-8 col-span-12">
//                             {[5, 4, 3, 2, 1].map((Total, index) => (
//                               <div
//                                 className="flex items-center space-x-4  mb-5 last:mb-0 "
//                                 key={index}
//                               >
//                                 <div className="flex-none">
//                                   <div className="flex space-x-1 text-xl  ">
//                                     {[1, 2, 3, 4, 5].map(
//                                       (individual, index1) => (
//                                         <Fragment key={index1}>
//                                           <iconify-icon
//                                             icon="heroicons:star-20-solid"
//                                             class={
//                                               Total - individual >= 0
//                                                 ? "text-tertiary"
//                                                 : "text-[#E6E6E6]"
//                                             }
//                                           ></iconify-icon>
//                                         </Fragment>
//                                       )
//                                     )}
//                                   </div>
//                                 </div>
//                                 <div className="flex-1">
//                                   <div className="progressbar-group flex items-center space-x-4">
//                                     <div className="rounded-[2px] overflow-hidden bg-opacity-10 bg-black h-[6px] relative flex-1">
//                                       <div
//                                         className="ani  h-[6px] bg-secondary block absolute left-0 top-1/2 -translate-y-1/2 "
//                                         style={{
//                                           width: props.CourseDetails
//                                             ? (props.CourseDetails.course_star[
//                                               Total
//                                             ] /
//                                               props.CourseDetails.course_star[
//                                               "total"
//                                               ]) *
//                                               100 !==
//                                               Infinity
//                                               ? (
//                                                 (props.CourseDetails
//                                                   .course_star[Total] /
//                                                   props.CourseDetails
//                                                     .course_star["total"]) *
//                                                 100
//                                               ).toFixed(2) + "%"
//                                               : "0%"
//                                             : "",
//                                         }}
//                                       ></div>
//                                     </div>
//                                     <div className="flex-none">
//                                       <span className=" block mb-2  font-semibold">
//                                         {props.CourseDetails
//                                           ? (props.CourseDetails.course_star[
//                                             Total
//                                           ] /
//                                             props.CourseDetails.course_star[
//                                             "total"
//                                             ]) *
//                                             100 !==
//                                             Infinity
//                                             ? (
//                                               (props.CourseDetails
//                                                 .course_star[Total] /
//                                                 props.CourseDetails
//                                                   .course_star["total"]) *
//                                               100
//                                             ).toFixed(2) + "%"
//                                             : "0%"
//                                           : ""}
//                                       </span>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </div>
//                             ))}
//                           </div>

//                           <div className="md:col-span-4 col-span-12">
//                             <div className="bg-white min-h-[219px] p-6 flex flex-col justify-center items-center shadow-box7 rounded space-y-3">
//                               <h2>{totalreview}</h2>
//                               <div className="flex space-x-3">
//                                 {[1, 2, 3, 4, 5].map((individual, index) => (
//                                   <iconify-icon
//                                     icon="heroicons:star-20-solid"
//                                     class={
//                                       individual - totalreview > 0
//                                         ? "text-[#E6E6E6]"
//                                         : "text-tertiary"
//                                     }
//                                     key={index}
//                                   ></iconify-icon>
//                                 ))}
//                               </div>
//                               <span className=" block">
//                                 (
//                                 {props.CourseDetails
//                                   ? props.CourseDetails.course_star["total"]
//                                   : ""}{" "}
//                                 Review)
//                               </span>
//                             </div>
//                           </div>
//                         </div>
//                         <div className=" mt-8">
//                           <h4 className=" text-xl font-bold text-black">
//                             Reviews
//                           </h4>
//                           <ul className=" list space-y-6 mt-6">
//                             {props.CourseDetails
//                               ? props.CourseDetails.course_review.map(
//                                 (Review, index) =>
//                                   Review.status === true && (
//                                     <li
//                                       className=" flex space-x-6 "
//                                       key={index}
//                                     >
//                                       <div className="flex-none">
//                                         <div className="h-[72px] w-[72px] rounded-full">
//                                           <img
//                                             src={cmnt1}
//                                             alt=""
//                                             className=" object-cover w-full h-full"
//                                           />
//                                         </div>
//                                       </div>
//                                       <div className="flex-1">
//                                         <div className="flex space-x-3 mb-4">
//                                           {[1, 2, 3, 4, 5].map(
//                                             (star, index1) => (
//                                               <Fragment key={index1}>
//                                                 <iconify-icon
//                                                   icon="heroicons:star-20-solid"
//                                                   class={
//                                                     star - Review.star > 0
//                                                       ? "text-[#E6E6E6]"
//                                                       : "text-tertiary"
//                                                   }
//                                                 ></iconify-icon>
//                                               </Fragment>
//                                             )
//                                           )}
//                                         </div>
//                                         <p>{Review.message}</p>
//                                         <div className="author mt-4">
//                                           <span className="block text-xl font-bold text-black">
//                                             {Review.reviewer_name}
//                                           </span>
//                                           <span className="block">
//                                             {Review.date}
//                                           </span>
//                                         </div>
//                                       </div>
//                                     </li>
//                                   )
//                               )
//                               : ""}
//                           </ul>
//                           {showReviewTab ? (
//                             <Course_Review
//                               setShowreviewtab={setShowReviewTab}
//                             />
//                           ) : (
//                             <span
//                               className="review-red"
//                               onClick={() => setShowReviewTab(true)}
//                             >
//                               Add A Review
//                             </span>
//                           )}
//                         </div>
//                       </div>
//                     </Tab.Panel>
//                   </Tab.Panels>
//                 </div>
//               </Tab.Group>
//             </div>
//           </div>
//           <div className="lg:col-span-4 col-span-12">
//             <div className="sidebarWrapper space-y-[30px]">
//               <div className="wdiget custom-text space-y-5 ">
//                 <a className="h-[220px] rounded relative block" href="#">
//                   <iframe
//                     src={`https://www.youtube.com/embed/${props.CourseDetails
//                       ? props.CourseDetails.PreviewVedioId
//                       : ""
//                       }`} // Replace {VIDEO_ID} with the actual YouTube video ID
//                     title="YouTube Video"
//                     allowFullScreen
//                     className="w-full h-full absolute top-0 left-0"
//                   ></iframe>
//                 </a>
//                 <h3>Upcoming Session</h3>
//                 {props.courseProps && props.courseProps.next_class_details && (
//                   <button
//                     className="btn btn-primary w-full text-center "
//                     onClick={handleJoinNow}
//                   >
//                     Join Now
//                   </button>
//                 )}
//                 <ul className="list  ">
//                   <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
//                     <div className="flex-1 space-x-3 flex">
//                       <img src={user} alt="" />
//                       <div className=" text-black font-semibold">
//                         Instructor
//                       </div>
//                     </div>
//                     <div className="flex-none">
//                       {props.courseProps && props.courseProps.batch_mentor_name}
//                     </div>
//                   </li>

//                   <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
//                     <div className="flex-1 space-x-3 flex">
//                       <img src={file2} alt="" />
//                       <div className=" text-black font-semibold">Lectures</div>
//                     </div>
//                     <div className="flex-none">
//                       {props.CourseDetails ? props.CourseDetails.lectures : ""}
//                     </div>
//                   </li>

//                   <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
//                     <div className="flex-1 space-x-3 flex">
//                       <img src={clockIcon} alt="" />
//                       <div className=" text-black font-semibold">Duration</div>
//                     </div>
//                     <div className="flex-none">
//                       {props.CourseDetails ? props.CourseDetails.duration : ""}
//                     </div>
//                   </li>
//                   <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
//                     <div className="flex-1 space-x-3 flex">
//                       <img src={target} alt="" />
//                       <div className=" text-black font-semibold">
//                         Session Schedule
//                       </div>
//                     </div>
//                     <div className="flex-none">
//                       {props.courseProps
//                         ? props.courseProps.next_class_details
//                           ? props.courseProps.next_class_details.startDateTime
//                             .split("T")
//                             .join(" ")
//                           : "No Sheduled Class"
//                         : ""}
//                     </div>
//                   </li>
//                 </ul>
//               </div>

//               {/*<div className="wdiget">
//                 <h4 className=" widget-title">Related Courses</h4>
//                 <ul className="list">
//                   <li className=" flex space-x-4 border-[#ECECEC] pb-6 mb-6 last:pb-0 last:mb-0 last:border-0 border-b">
//                     <div className="flex-none ">
//                       <div className="h-20 w-20  rounded">
//                         <img
//                           src={rc1}
//                           alt=""
//                           className=" w-full h-full object-cover rounded"
//                         />
//                       </div>
//                     </div>
//                     <div className="flex-1 ">
//                       <div className="flex space-x-3 mb-2">
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                       </div>
//                       <div className="mb-1 font-semibold text-black">
//                         Greatest Passion In...
//                       </div>
//                       <span className=" text-secondary font-semibold">
//                         $38.00
//                       </span>
//                     </div>
//                   </li>
//                   <li className=" flex space-x-4 border-[#ECECEC] pb-6 mb-6 last:pb-0 last:mb-0 last:border-0 border-b">
//                     <div className="flex-none ">
//                       <div className="h-20 w-20  rounded">
//                         <img
//                           src={rc2}
//                           alt=""
//                           className=" w-full h-full object-cover rounded"
//                         />
//                       </div>
//                     </div>
//                     <div className="flex-1 ">
//                       <div className="flex space-x-3 mb-2">
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                       </div>
//                       <div className="mb-1 font-semibold text-black">
//                         Greatest Passion In...
//                       </div>
//                       <span className=" text-secondary font-semibold">
//                         $38.00
//                       </span>
//                     </div>
//                   </li>
//                   <li
//                     className=" flex space-x-4 border-[#ECECEC] pb-6 mb-6 last:pb-0 last:mb-0 
//                    last:border-0 border-b"
//                   >
//                     <div className="flex-none ">
//                       <div className="h-20 w-20  rounded">
//                         <img
//                           src={rc3}
//                           alt=""
//                           className=" w-full h-full object-cover rounded"
//                         />
//                       </div>
//                     </div>
//                     <div className="flex-1 ">
//                       <div className="flex space-x-3 mb-2">
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                         <iconify-icon
//                           icon="heroicons:star-20-solid"
//                           class="text-tertiary"
//                         ></iconify-icon>
//                       </div>
//                       <div className="mb-1 font-semibold text-black">
//                         Greatest Passion In...
//                       </div>
//                       <span className=" text-secondary font-semibold">
//                         $38.00
//                       </span>
//                     </div>
//                   </li>
//                 </ul>
//                                   </div>*/}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div >
//   );
// };

// export default CourseDetails;














/* eslint-disable jsx-a11y/anchor-is-valid */
import { Disclosure, Tab } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";
import { ClassicSpinner, MagicSpinner } from "react-spinners-kit";
import { CourseCloudFrontDistributionID, DownloadFileFromS3, FetchSessionDetails } from "../../api/aws-api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from "react-router-dom";
import { UpdatePostgreSQL } from "../../api/aws-api";
import { ConstructorEventPost, ConstructorEventGet } from "../../Event/event";
import {
  author,
  camera,
  fb,
  file2,
  headphone,
  instra,
  laptop,
  likeIcon,
  ln,
  lock,
  Anglofone_CourseImage,
  starIcon,
  target,
  twitter,
  user,
  user2,
  ux,
  yt,
  rc1,
  rc2,
  rc3,
  clockIcon,
  cmnt1,
  dymmyUser,
} from "../../constant/images";
import Course_Review from "./Course_Review";



const CourseDetails = (props) => {

  useEffect(() => {
    const userId = JSON.parse(localStorage.getItem("UserKey"))
    const userData = JSON.parse(sessionStorage.getItem("UserData"))
    console.log(`the userId in local is ${userId.user_id}`)
    console.log(`the userdata in session is ${userData.user_name}`)
    console.log(`the usertype in session is ${userData.user_type}`)
    console.log(`the mentor name for the particular course is ${props.courseProps.batch_mentor_name}`)

    const datass = {
      userId: userId.user_id,
      userName: userData.user_name,
      mentorName: props.courseProps.batch_mentor_name,
      userType: userData.user_type
    }

    console.log(datass)

    setCallActivityData(datass)
  }, [])



  const [showReviewTab, setShowReviewTab] = useState(false);
  const [callActivityData, setCallActivityData] = useState({})
  const [ModuleID, setMOduleID] = useState(null)
  const [TaskID, setTaskID] = useState(null)
  const [userId, setUserId] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [taskId, setTaskId] = useState(null);
  const [moduleId, setModuleId] = useState(null);
  const navigate = useNavigate();
  const module_id = props
  console.log(module_id)

  // ===== Downloads tab state (moved in from the old standalone Downloads.jsx page) =====
  const [session, setSession] = useState([]);
  const [downloadingLoading, setDownloadingLoading] = useState("");

  useEffect(() => {
    if (props.CourseDetails && props.CourseDetails.course_id) {
      fetchSessionDetails();
    }
  }, [props.CourseDetails]);

  const fetchSessionDetails = async () => {
    const responsedata = await ConstructorEventGet(FetchSessionDetails, {
      course_id: props.CourseDetails.course_id,
    });
    setSession(responsedata && Array.isArray(responsedata.session) ? responsedata.session : []);
  };

  const downloadfile = async (item) => {
    setDownloadingLoading(item.FileKey);
    const s3FileName = props.CourseDetails.course_id + "/downloads/" + item.FileKey;
    const responsedata = await ConstructorEventPost(DownloadFileFromS3, {
      file_name: s3FileName,
    });
    downloadPDFFromURL(responsedata);
  };

  const downloadPDFFromURL = async (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setDownloadingLoading("");
  };
  // ===== end Downloads tab state =====

  const calculateTotalReview = () => {
    if (
      props.CourseDetails !== undefined &&
      props.CourseDetails.course_star !== undefined
    ) {
      let total_starvalue = 0;
      for (let i = 1; i < 6; i++) {
        total_starvalue =
          total_starvalue + props.CourseDetails.course_star[i] * parseInt(i);
      }
      const percentage = (
        total_starvalue / parseInt(props.CourseDetails.course_star["total"])
      ).toFixed(1);
      return percentage;
    }
  };
  const totalreview = calculateTotalReview();

  const handleJoinNow = () => {
    const meetLink =
      props.courseProps && props.courseProps.next_class_details.meet_link;
    console.log(meetLink, "lommk");
    window.open(meetLink, "_blank"); // Open the meet link in a new tab
  };

  const HandleActivityNavigation = (resource) => {
    console.log(`the resource url is ${resource.url}`)
    console.log(`the module id is ${resource.module_id}`)
    console.log(`the task id is ${resource.task_id}`)

    localStorage.setItem("module_id", resource.module_id)
    localStorage.setItem("task_id", resource.task_id)

    const storedModuleId = localStorage.getItem("module_id")
    const storedTaskId = localStorage.getItem("task_id")

    const storedUserId = localStorage.getItem("UsersID");
    const storedCourseId = localStorage.getItem("Course_ID")

    const batchdetails = JSON.parse(localStorage.getItem("batch_Details") || "[]");



    if (resource.url === "/codomo/codeeditor") {
      navigate("/codomo/codeeditor", {
        state: { resource: resource, CourseProps: props.courseProps },
      });
    } else if (resource.url === "/codomo/AcitivityCourse") {
      navigate("/codomo/AcitivityCourse", {
        state: { resource: resource, CourseProps: props.courseProps },
      });
    } else if (resource.url === "/codomo/NewAcitivityCourse") {
      navigate("/codomo/NewAcitivityCourse");
    } else if (resource.url.includes("onecompiler.com")) {
      // navigate("/codomo/onecompiler",{state: {"Url" : resource.url}})
      sessionStorage.setItem("OneCompilerUrl", resource.url);
      const newTab = window.open("", "_blank");

      // Navigate in the new tab or window
      newTab.location = "/codomo/onecompiler";
    } else if (resource.url.includes("onecompiler.com")) {
      sessionStorage.setItem("OneCompilerUrl", resource.url);
      const newTab = window.open("", "_blank");
      newTab.location = "/codomo/onecompiler";
    } else if (resource.url.includes("scratch.mit.edu")) {
      // Open EXACT URL from resource.url
      window.open(resource.url, "_blank", "noopener,noreferrer");


    } else if (resource.url.includes("polypad")) {

      sessionStorage.setItem("OneCompilerUrl", resource.url);
      const newTab = window.open("", "_blank");

      // Navigate in the new tab or window
      newTab.location = "/codomo/onecompiler";



    }
    else {
      console.log('the module id is ', storedModuleId)
      console.log("the task id is", storedTaskId)
      console.log('the course 1 is ', storedCourseId)
      console.log("the user id is", storedUserId)
      console.log("the batch is", batchdetails)

      const matchedBatch = batchdetails.find(batch => batch.course_id === storedCourseId);



      if (matchedBatch) {
        console.log("Matching batch_id is:", matchedBatch.batch_id);
        localStorage.setItem("batch_id_match", matchedBatch.batch_id)


      } else {
        console.warn("No batch found for course_id:", storedCourseId);
      }


      if (storedUserId && storedCourseId && storedModuleId && storedTaskId && matchedBatch) {

        function getISTTimeString() {
          const now = new Date();

          const year = now.getFullYear();
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const day = String(now.getDate()).padStart(2, "0");
          const hours = String(now.getHours()).padStart(2, "0");
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const seconds = String(now.getSeconds()).padStart(2, "0");

          return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
        }

        const istISOString = getISTTimeString();

        console.log("IST time is:", istISOString);

        console.log("UserID is", storedUserId);
        console.log("CourseID is", storedCourseId);
        console.log("TAskID is", storedTaskId);
        console.log("ModuleID is", storedModuleId);
        console.log("batch id is ss", matchedBatch.batch_id)
        setUserId(storedUserId);
        setCourseId(storedCourseId);
        setTaskId(storedTaskId)
        setModuleId(storedModuleId)


        console.log("time is ", istISOString)

        const params = {
          user_id: storedUserId,
          course_id: storedCourseId,
          module_id: storedModuleId,
          task_id: storedTaskId,
          completed_at: istISOString,
          last_updated: istISOString,
          batch_id: matchedBatch.batch_id
        };

        const postCompletionEvent = async () => {
          try {
            const responsedata = await ConstructorEventPost(UpdatePostgreSQL, params);
            console.log("Event post success:", responsedata);
          } catch (error) {
            console.error("Event post failed:", error);
          }
        };

        postCompletionEvent();

      } else {
        console.log("Waiting for IDsss...");
      }


      // window.open(resource.url, "_blank", "noopener noreferrer");
      // window.open(resource.url, "_self");
      window.open(resource.url, "_blank", "noopener,noreferrer");


    }
  };

  function goToVoiceCallPage() {
    console.log(callActivityData)
    navigate("/voiceCallActivity", { state: callActivityData })
    // navigate("/chatScreen", { state: callActivityData })
  }

  function goToVideoCallPage() {
    console.log(callActivityData)
    navigate("/videoCallActivity", { state: callActivityData })
  }

  function goToChatScreenPage() {
    navigate("/chatScreen", { state: callActivityData });
  }



  return props.loading ? (
    <div className="spinner">
      <div className="spinner-wrapper">
        <ClassicSpinner size={50} color="black" loading={props.loading} />
      </div>
    </div>
  ) : (
    <div className="nav-tab-wrapper tabs  section-padding">
      <div className="container">
        <div className="grid grid-cols-12 gap-[30px]">
          <div className="lg:col-span-8 col-span-12">
            <div className="single-course-details">

              <div className="mb-6" style={{ display: "flex", justifyContent: "space-between" }}>
                <span className="bg-secondary py-1 px-3 text-lg font-semibold rounded text-white">
                  {props.CourseDetails
                    ? props.CourseDetails.course_catogory
                    : "course_catogory"}
                </span>
                <div>
                </div>

              </div>
              <h2>
                {props.CourseDetails
                  ? props.CourseDetails.course_name
                  : "course_name"}
              </h2>
              <Tab.Group>
                <div className="nav-tab-wrapper mt-12">
                  <Tab.List as="ul" id="tabs-nav" className="course-tab mb-8" style={{ display: "flex", listStyle: "none", padding: 0, marginBottom: 30 }}>
                    {["Curriculum", "Downloads"].map((item, index) => (
                      <Tab as="li" key={index} style={{ flex: 1, listStyle: "none" }}>
                        {({ selected }) => (
                          <span
                            style={{
                              display: "block",
                              width: "100%",
                              borderRadius: 5,
                              textAlign: "center",
                              padding: "16px 24px",
                              fontWeight: 600,
                              cursor: "pointer",
                              backgroundColor: selected ? "#FF7E84" : "#ECECEC",
                              color: selected ? "#ffffff" : "#827878",
                            }}
                          >
                            {item}
                          </span>
                        )}
                      </Tab>
                    ))}
                  </Tab.List>
                  <Tab.Panels id="tabs-content">

                    {/* ===== Curriculum panel (unchanged) ===== */}
                    <Tab.Panel id="tab2" className="tab-content">
                      <div>
                        <h3 className=" text-2xl">Course Description</h3>
                        <div className="md:flex md:space-x-10  space-x-3 flex-wrap mt-4 mb-6">
                          <span>
                            {props.CourseDetails
                              ? props.CourseDetails.description
                              : "description"}
                          </span>
                        </div>
                        <span>
                          <h5>
                            Lectures Total:{" "}
                            {props.CourseDetails
                              ? props.CourseDetails.duration
                              : "description"}
                          </h5>
                        </span>
                        <ul className="list  course-accrodain space-y-6">
                          {props.CourseDetails
                            ? props.CourseDetails.modules.map(
                              (module, index) => (
                                <Disclosure as="li">
                                  {({ open }) => (
                                    <li
                                      className={open ? "open" : ""}
                                      key={index}
                                    >
                                      <Disclosure.Button
                                        as="button"
                                        className="accrodain-button"
                                      >
                                        <span className="icon-pm fle x-none"></span>
                                        <span className=" flex-1">
                                          {module.module_name}
                                        </span>
                                        <div className="flex-none extra-text  hidden sm:block">
                                          {module.Lectures} Lectures,{" "}
                                          {module.TotalDurationInMinutes} min
                                        </div>
                                      </Disclosure.Button>
                                      <Disclosure.Panel>
                                        <div className="content">
                                          <div className=" text-xl font-semibold text-black mb-2">
                                            {module.description_head}
                                          </div>
                                          <p>{module.description}</p>
                                          <div className=" text-xl font-semibold text-black mb-2 mt-6">
                                            {module.resource_count
                                              ? module.resource_count.video
                                                ? module.resource_count
                                                  .video + " Videos  "
                                                : ""
                                              : ""}
                                            {module.resource_count
                                              ? module.resource_count.audio
                                                ? module.resource_count
                                                  .audio + " Audio  "
                                                : ""
                                              : ""}
                                            {module.resource_count
                                              ? module.resource_count.activity
                                                ? module.resource_count
                                                  .activity + " Activity  "
                                                : ""
                                              : ""}
                                          </div>
                                          <div className=" mt-8 "   >
                                            {module.resource.map(
                                              (resource, index) => (
                                                <div
                                                  className="flex items-start pb-4 mb-4 last:mb-0 last:pb-0 border-b border-[#ECECEC] last:border-0"
                                                  key={index}
                                                  onClick={() =>
                                                    HandleActivityNavigation(
                                                      resource
                                                    )
                                                  }
                                                >
                                                  <div className="flex-1 flex"  target="_blank">
                                                    <span className="flex-none mr-2"  >
                                                      <img
                                                        src={
                                                          resource.type ===
                                                            "Video"
                                                            ? camera
                                                            : resource.type ===
                                                              "Audio"
                                                              ? headphone
                                                              : resource.type ===
                                                                "Activity"
                                                                ? laptop
                                                                : ""
                                                        }
                                                        alt=""
                                                      />
                                                    </span>

                                                    <span className="flex-1"  >
                                                      {" "}
                                                      {resource.type}:{" "}
                                                      {resource.description}{" "}
                                                    </span>
                                                  </div>
                                                  <div className="flex-none flex space-x-3"  >
                                                    {resource.preview ? (
                                                      <span className="bg-primary text-white px-3 rounded">
                                                        Preview
                                                      </span>
                                                    ) : (
                                                      ""
                                                    )}

                                                    {resource.locked ? (
                                                      <img
                                                        src={lock}
                                                        alt=""
                                                      />
                                                    ) : (
                                                      ""
                                                    )}
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      </Disclosure.Panel>
                                    </li>
                                  )}
                                </Disclosure>
                              )
                            )
                            : " error"}
                        </ul>
                      </div>
                    </Tab.Panel>

                    {/* ===== Downloads panel (new — replaces the old Mentor-info panel) ===== */}
                    <Tab.Panel id="tab3" className="tab-content">
                      <div className="text-center mb-8">
                        <div className="mini-title">Downloads</div>
                        <div className="column-title">
                          Select <span className="shape-bg">Topics</span> To Download
                        </div>
                      </div>
                      <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-[30px]">
                        {session.map((item, index) => (
                            <button
                              className="rounded-[8px] transition duration-100 hover:shadow-box hover:bg-white group bg-[#FFE8E8] text-center px-6 py-8 hover:-translate-y-2"
                              key={index}
                              onClick={() => !downloadingLoading && downloadfile(item)}
                            >
                            <div className="w-[72px] h-[72px] rounded-full bg-white relative mx-auto flex flex-col justify-center items-center mb-8 group-hover:bg-[#FFE8E8]">
                              {downloadingLoading === item.FileKey ? (
                                <MagicSpinner size={40} color="black" loading="true" />
                              ) : (
                                <iconify-icon icon="material-symbols:cloud-download-rounded" style={{ fontSize: "2em" }} />
                              )}
                            </div>
                            <div className="course-content">
                              <h4 className="text-2xl mb-2 font-bold">{item.SessionName}</h4>
                            </div>
                          </button>
                        ))}
                      </div>
                    </Tab.Panel>

                  </Tab.Panels>
                </div>
              </Tab.Group>
            </div>
          </div>
          <div className="lg:col-span-4 col-span-12">
            <div className="sidebarWrapper space-y-[30px]">
              <div className="wdiget custom-text space-y-5 ">
                <a className="h-[220px] rounded relative block" href="#">
                  <iframe
                    src={`https://www.youtube.com/embed/${props.CourseDetails
                      ? props.CourseDetails.PreviewVedioId
                      : ""
                      }`}
                    title="YouTube Video"
                    allowFullScreen
                    className="w-full h-full absolute top-0 left-0"
                  ></iframe>
                </a>
                <h3>Upcoming Session</h3>
                {props.courseProps && props.courseProps.next_class_details && (
                  <button
                    className="btn btn-primary w-full text-center "
                    onClick={handleJoinNow}
                  >
                    Join Now
                  </button>
                )}
                <ul className="list  ">
                  <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
                    <div className="flex-1 space-x-3 flex">
                      <img src={user} alt="" />
                      <div className=" text-black font-semibold">
                        Instructor
                      </div>
                    </div>
                    <div className="flex-none">
                      {props.courseProps && props.courseProps.batch_mentor_name}
                    </div>
                  </li>

                  <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
                    <div className="flex-1 space-x-3 flex">
                      <img src={file2} alt="" />
                      <div className=" text-black font-semibold">Lectures</div>
                    </div>
                    <div className="flex-none">
                      {props.CourseDetails ? props.CourseDetails.lectures : ""}
                    </div>
                  </li>

                  <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
                    <div className="flex-1 space-x-3 flex">
                      <img src={clockIcon} alt="" />
                      <div className=" text-black font-semibold">Duration</div>
                    </div>
                    <div className="flex-none">
                      {props.CourseDetails ? props.CourseDetails.duration : ""}
                    </div>
                  </li>
                  <li className=" flex space-x-3 border-b border-[#ECECEC] mb-4 pb-4 last:pb-0 past:mb-0 last:border-0">
                    <div className="flex-1 space-x-3 flex">
                      <img src={target} alt="" />
                      <div className=" text-black font-semibold">
                        Session Schedule
                      </div>
                    </div>
                    <div className="flex-none">
                      {props.courseProps
                        ? props.courseProps.next_class_details
                          ? props.courseProps.next_class_details.startDateTime
                            .split("T")
                            .join(" ")
                          : "No Sheduled Class"
                        : ""}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default CourseDetails;